import axios from "axios";
import { Config } from "../Config";
import {
  clearLocalStorageExcept,
  userAccessToken,
  setSecureData,
} from "../helpers";

// ---- SAME-FILE NAV BRIDGE ----
let _navigate = null;

// Called once from inside a Router-aware component
export const bindPatientsNavigate = (navigateFn) => {
  _navigate = navigateFn;
};

const appNavigate = (to, options) => {
  if (_navigate) {
    _navigate(to, options);
  } else {
    console.warn("Navigate not bound yet, ignoring redirect:", to);
  }
};
// --------------------------------

const API = axios.create({
  baseURL: Config.patientServerUrl,
});

API.interceptors.request.use(
  (config) => {
    const token = userAccessToken();
    config.headers = config.headers || {};
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response) {
      switch (error.response.status) {
        case 401: {
          await clearLocalStorageExcept();

          const excludedPaths = ["/", "/no-practices-found"];
          const currentPath =
            window.location.pathname + window.location.search;

          if (!excludedPaths.includes(window.location.pathname)) {
            await setSecureData("redirect", currentPath);
          }

          if (!window.location.pathname.includes("/login")) {
            appNavigate("/login", { replace: true });
          }
          break;
        }
        case 404:
          // handle 404 if needed
          break;
        default:
          // other errors
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default API;
